import { MunicipalityFilter } from './../../models/municipality-filter.mode';
import { HttpParams } from '@angular/common/http';
import { MunicipalityModel } from './../../models/municipality.model';

export class FilterMunicipalities {
  static readonly type = '[Municipality-State] Filter Municipalities';
  constructor(public params?: HttpParams, public filter?: MunicipalityFilter) {}
}
export class FilterMunicipalitiesWithoutFiltering {
  static readonly type =
    '[Municipality-State] Filter Municipalities Without Filtering';
  constructor(public language: string) {}
}

export class AddMunicipality {
  static readonly type = '[Municipality-State] Add Municipality';
  constructor(public model: MunicipalityModel) {}
}

export class EditMunicipality {
  static readonly type = '[Municipality-State] Edit Municipality';
  constructor(public model: MunicipalityModel) {}
}

export class RemoveMunicipality {
  static readonly type = '[Municipality-State] Remove Municipality';
  constructor(public modelId: string) {}
}

export class ImportMunicipalities {
  static readonly type = '[Municipality-State] Import Municipalities';
  constructor(public data: string) {}
}
